class ResizeGuard {
  constructor(vue, swiper) {
    this._resizeThrottler = null
    this.resizeTimeout = null;
    this.createGuard()
    this.listners = {}
  }

  createGuard() {
    const actualResizeHandler = () => {
      for (let k in this.listners) {
        const { _vue, _swiper } = k
        if (_vue && _vue.$refs && _vue.$refs[_swiper]) {
          _vue.$refs[_swiper].resize()
        }
      }
    }

    this._resizeThrottler = () => {
      // ignore resize events as long as an actualResizeHandler execution is in the queue
      if (!this.resizeTimeout) {
        this.resizeTimeout = setTimeout(() => {
          this.resizeTimeout = null
          actualResizeHandler()
          // The actualResizeHandler will execute at a rate of 15fps
        }, 1000)
      }
    }
    window.addEventListener('resize', this._resizeThrottler, false)
  }

  addGuard(vue, swiper) {
    const timestamp = Date.now()
    this.listners[timestamp] = { vue, swiper }
    return timestamp
  }

  removeGuard(guardId) {
    this.listners[guardId] = null
  }

  teardown() {
    window.removeEventListener('resize', this._resizeThrottler, false)
    this._resizeThrottler = null
    clearTimeout(this.resizeTimeout)
    this.resizeTimeout = null
  }
}

let resizeGuard

export default {
  /**
   * 解决窗口大小发生变化时，vant swipe尺寸不更新问题，建议所有使用vant swipe组件的页面添加该方法
   * @param {*} vue Vue实例
   * @param {*} swiper  swipe对应的ref name
   */
  swipeResize(vue, swiper) {
    if (!resizeGuard) {
      resizeGuard = new ResizeGuard(vue, swiper)
    }
    return resizeGuard.addGuard(vue, swiper)
  },
  removeSwipeResize(guardId) {
    resizeGuard && resizeGuard.removeGuard(guardId)
  },
  teardownResizeGuard() {
    resizeGuard.teardown()
    resizeGuard = undefined
  }
}
